(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('EmailTrackpointModalController', EmailTrackpointModal);

    EmailTrackpointModal.$inject = ['TrackpointService', 'currentCampaign', 'selectedTrackpoints'];
    function EmailTrackpointModal(TrackpointService, currentCampaign, selectedTrackpoints) {
        var vm = this;

        //TODO: fetch email of currently logged in user. Might need a User service for that.

        vm.sendEmails = function (emails) {
            if (!emails) return;
            if (selectedTrackpoints.length == 1) {
                Notification.onTrackpointEmail(emails);
            } else if (selectedTrackpoints.length > 1) {
                Notification.onTrackpointEmailMany(emails, selectedTrackpoints.length);
            }
            TrackpointService.email({
                'campaign': currentCampaign.name,
                'trackpoints': selectedTrackpoints,
                'emails': emails
            });
        }
    }
})();
